module.exports = __webpack_public_path__ + "static/media/11_before.24428503.jpg";